export default __webpack_public_path__ + "b7e47a3748df80bbcdb7ecb515c080cd.png";